<!-- Titolo -->
<div class="ui-g-12 campaign-step-title flex-align-center">
  <div class="ui-g-12 ui-md-8">
    <h2>{{'campaign.actionChoiceTitle' | translate}} {{campaignName}}</h2>
  </div>
  <div class="ui-g-12 ui-md-4 text-right">
    <button
      pButton
      type="button"
      class="k-generic-btn"
      icon="fa fa-angle-left"
      iconPos="left"
      label="{{ 'common.back' | translate }}"
      (click)="goBack()">
    </button>
  </div>
</div>
<div class="ui-g-12">
  <div class="ui-g-12">
    <h3 class="section-title">
      {{ 'campaign.setCampaignTemplate' | translate }}
    </h3>
  </div>
</div>

<!-- Card Scelta Action -->

<div *ngIf="actions && actions.length > 0" class="ui-g-12">
  <div class="ui-g-12 ui-md-3" *ngFor="let action of actions">
    <div class="card-action">
      <div class="title-card">
        <p>{{action.name}}</p>
      </div>
      <div class="content-card">
        <p>
          {{action.description}}
        </p>
      </div>
      <div class="footer-card text-right">
        <!-- Riabilitare in caso venga richiesto di nuovo la visualizzazione dei button di scelta dei layout -->
        <!-- <i class="fa fa-arrow-right icon-campaign-arrow" (click)="viewButton(action.id)"></i> -->
        <i class="fa fa-arrow-right icon-campaign-arrow" (click)="goToEmission(action)"></i>
      </div>
    </div>
  </div>
</div>

<!-- Buttons scelta layout -->
<div *ngIf="button" class="ui-g-12 ui-md-4">
  <div class="campaign-button flex-align-center" (click)="goToEmission()">
    <div class="campaign-button__label">
      {{ 'campaign.newCustomPackage' | translate }}
    </div>
    <div class="text-right">
      <i class="fa fa-arrow-right icon-campaign-arrow"></i>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-action-setup/campaign-action-setup.component.html